import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

import { useVehicleDataChangeForm } from "./hooks/useVehicleDataChangeForm";
import VehicleDataForm from "./components/VehicleDataForm";
import Documents from "./components/Documents";
import { Form, FormErrorBox } from "core/hookForm";
import i18n from "core/i18n";
import { Loading, Typography } from "ui-library/atoms";
import { ContentBox } from "ui-library/layouts";
import vehicleDataChange from "serverApi/vehicleDataChange";
import { FORM_CONTRACT_VEHICLE_DATA } from "app/pages/detailVehicle/constants";
import { ChangeSuccessTextType } from "types";
import { InPageHookFormLayout } from "containers/inPageForm";

export default function VehicleDataChangeForm() {
    const { form, onSubmit, vehicles, step, previousStep, isFormLoading, isSubmitting, contractNumber } = useVehicleDataChangeForm();
    const { t } = i18n.useTranslation();
    const { idObject } = useParams();

    const [isFeasible, setIsFeasible] = useState<boolean>(undefined);

    useEffect(() => {
        async function fetchIsFeasible() {
            try {
                const [error, res] = await vehicleDataChange.isFeasible(idObject);

                setIsFeasible(error ? false : res.body.isFeasible);
            } catch (err) {
                console.error(err);
            }
        }

        fetchIsFeasible();
    }, [idObject]);

    if (isFeasible === true) {
        return (
            <Form form={form} onSubmit={onSubmit}>
                <InPageHookFormLayout
                    formName={FORM_CONTRACT_VEHICLE_DATA}
                    formTitle={t("vehicle.change.vehicleData.title", { contractNumber })}
                    isFormSubmitted={step === 3}
                    changeSuccessTextType={ChangeSuccessTextType.SERVICE_HUB_CHANGE_WITHOUT_SIGNATURE_PROCESSED}
                    showFeedbackSurvey
                >
                    <Loading loading={isFormLoading}>
                        <FormErrorBox />

                        {step === 1 && <VehicleDataForm onSubmit={onSubmit} vehicles={vehicles} isSubmitting={isSubmitting} />}
                        {step === 2 && <Documents previousStep={previousStep} />}
                    </Loading>
                </InPageHookFormLayout>
            </Form>
        );
    } else if (isFeasible === false) {
        return (
            <ContentBox mt={3}>
                <Typography variant={"b"}>{t("vehicle.change.notFeasible.edit")}</Typography>
            </ContentBox>
        );
    }

    return <span>...</span>;
}
